export interface Contract{
    id: string,
    name: string,
    number: string,
    licences: Licences,
    instanceName: string,
    instanceId: string,
    synchronized: boolean
}

export interface ContractAudit{
    id: string,
    contractNumber: string,
    action: string,
    timestamp: Date,
    oldContract: string,
    newContract: string
}

export enum ContractActionType {
    Recent = "Recent", // Shows recent history without any filter
    Deleted = "Deleted",
    Renewed = "Renewed",
    Created = "Created",
    Updated = "Updated"
}
export interface Licences {
    information: number,
    guestRegistration: number,
    meet: number,
    wall: number,
    poster: number,
    sessions: number,
    calmviso: number
}
